module.exports = "/_next/static/images/gmail-4af40f4efff87ac0f480d274548dd718.png";